import { Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toggleLoading } from "Redux/loadingSlice";
import { baseUrl } from "Shared/BaseUrl";
import { createNotification } from "Utils/CreateNotification";
import { EBSRequest } from "Utils/EBSRequest";
import CustomTextInput from "Components/Common/Input/CustomTextInput";
import { routes } from "Components/routes";

const ResetPassword = () => {
    let { token } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);


    useEffect(() => {
        const checkToken = async (token: string | undefined) => {
            setIsLoading(true)
            await axios({
                method: 'GET',
                url: baseUrl + `verify-token?token=${token}`,
            })
                .then((res) => {
                    setIsLoading(false)
                })
                .catch((e) => {
                    setIsLoading(false)
                    if (e.response.status === 400) {
                        createNotification('error', 'Invalid token')
                        navigate(routes.index)
                    }
                })
        }
        checkToken(token)
    }, [navigate, token])



    const form = useForm({
        initialValues: {
            password: '',
            password_confirmation: '',
            token: token,
        },
        validate: {
            password: (value) => (value.length < 1 ? 'Password name is required' : null),
            password_confirmation: (value, values) =>
                value !== values.password ? 'Passwords did not match' : null,
        }
    })


    const handleSubmit = async (val: {
        password: string;
        password_confirmation: string;
        token: string | undefined;
    }) => {
        form.validate();
        var formData = new FormData();
        await import('Utils/FormHelper')
            .then(({ FormHelper }) => { formData = FormHelper.addToForm(val) })

        dispatch(toggleLoading(true));

        const { data, status } = await EBSRequest.post('create-password', formData, dispatch);
        if (status === 422) {
            form.setErrors(data.errors);
        }
        dispatch(toggleLoading(false));
        if (status === 200) navigate(routes.index);
    }

    return (
        <>
            <div className="vw-100 vh-100 d-flex justify-content-center align-items-center">
                {isLoading ? <p className="mb-0 mt-0" style={{ fontSize: 20, fontWeight: 600, color: "#2465ea" }}>Everest Billing System</p> : <div className="border rounded-3 shadow-sm py-4 px-2 px-md-4 px-lg-5">
                    <div>
                        <p className="mb-0 mt-0" style={{ fontSize: 15, fontWeight: 600, color: "#0f193a" }}>Welcome to</p>
                        <p className="mb-0 mt-0" style={{ fontSize: 20, fontWeight: 600, color: "#2465ea" }}>Everest Billing System</p>
                        <p className="mb-0 mt-0" style={{ fontSize: 13 }}>Please create a new password to get started with the application.</p>
                    </div>
                    <div className="mt-4">
                        <form onSubmit={form.onSubmit(handleSubmit)}>
                            <CustomTextInput className="col-12 col-md-9"
                                title="Password"
                                required
                                value={form.values.password}
                                onChange={(e) => { form.setValues({ ...form.values, password: e.target.value }) }}
                                errorMsg={form.errors.password}
                                type="password"
                            />
                            <CustomTextInput className="col-12 col-md-9"
                                title="Re-type Password"
                                required
                                value={form.values.password_confirmation}
                                onChange={(e) => { form.setValues({ ...form.values, password_confirmation: e.target.value }) }}
                                errorMsg={form.errors.password_confirmation}
                                type="password"
                            />
                            <Button className="mt-4" styles={(theme) => ({
                                root: {
                                    backgroundColor: '#0F193A',
                                    border: 0,
                                    height: 35,
                                    paddingLeft: 15,
                                    paddingRight: 15,
                                    color: '#fff',

                                    '&:hover': {
                                        backgroundColor: theme.fn.lighten('#0F193A', 0.05),
                                    },
                                },

                            })} variant="light" type="submit">Continue</Button>
                            <div className="mb-0 mt-3">
                                <Link to={'/'} style={{ fontSize: 13 }}>Go Back to Login</Link>
                            </div>
                        </form>
                    </div>
                </div>}
            </div>
        </>

    );
}

export default ResetPassword;